import { cn } from "@/libs/utils";
import { WEBVIEW_ROUTES } from "@/components/webview/route";
import Link from "next/link";
import { useTrans } from "@/utils/useTrans";
import SearchIconWebView from "@/components/webview/icon/SearchIconWebView";

type GamesSearchInputProps = {
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  onClick?: () => void;
};

export const GamesSearchInputWebView = ({
  className,
  onClick,
}: GamesSearchInputProps) => {
  const { t } = useTrans(["games"]);
  const handleClick = () => {
    onClick?.();
  };

  return (
    <Link
      href={WEBVIEW_ROUTES.webviewSearchPreview}
      onClick={handleClick}
      className={cn(
        "relative flex w-full cursor-pointer items-center justify-center px-4 pt-[14px]",
        className,
      )}
    >
      <div
        onClick={handleClick}
        className={cn(
          "relative flex w-full cursor-pointer items-center justify-center",
          className,
        )}
      >
        <SearchIconWebView className="absolute left-2 top-1/2 size-6 -translate-y-1/2 transform text-[#898989]" />
        {/*input 처럼 보이는 div */}
        <div
          className={cn(
            "flex-1 rounded-lg border border-[#3F3F3F] bg-transparent py-[8px] pl-10 text-[16px] leading-[24px] text-[#5C5C5C] placeholder:text-[#5C5C5C]",
            className,
          )}
        >
          {t("Search for Supported Games")}
        </div>
      </div>
    </Link>
  );
};
